import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductKey } from 'src/app/core';
import { PlatformService } from '@core/service/platform.service';
import { SecurityService } from '@mynexus/mynexus-ui-lib';
import { dailyDashboardProductConfig } from '@shared/constants';
import { ProductItem } from '@shared/model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'product-selector',
    templateUrl: './product-selector.component.html',
    styleUrls: ['./product-selector.component.scss'],
    standalone: false
})
export class ProductSelectorComponent implements OnInit {
  @Input() set defaultProduct(product: ProductKey) {
    this.selectedProduct = product;
  }

  @Output() changeProduct = new EventEmitter<ProductKey>();

  productNames: ProductItem[] = [];
  selectedProduct!: string;

  constructor(
    private securityService: SecurityService,
    private platformService: PlatformService,
  ) {}

  ngOnInit(): void {
    this.productNames = dailyDashboardProductConfig.reduce(
      (queues: ProductItem[], { option, access }) => {
        if (this.securityService.hasAccess(access)) {
          queues.push(option);
        }

        return queues;
      }, []);
  }

  setActiveProduct(product: ProductKey): void {
    this.platformService.setCurrentProduct(product);

    this.changeProduct.emit(product);
  }
}
